export default __webpack_public_path__ + "static/media/ars-maquette-bold-webfont.f622761a.woff";